import { JawsScanCreate, JawsScanResponse, JawsScanSummaryResponse } from '@/schema/jawsScan';
import Api from './api';
import { JawsScanUpdate } from '@schema/jawsScan.ts';

const JawsScanApi = {
  getById(id: string) {
    return Api.get<JawsScanResponse>(`/jaws-scans/${id}`);
  },

  getSummaryById(id: string) {
    return Api.get<JawsScanSummaryResponse>(`/jaws-scans/${id}/summary`);
  },

  getByPatientId(patientId: string) {
    return Api.get<JawsScanResponse[]>(`/jaws-scans/patient/${patientId}`);
  },

  getSummaryByPatientId(patientId: string) {
    return Api.get<JawsScanSummaryResponse[]>(`/jaws-scans/patient/${patientId}/summary`);
  },

  create(data: JawsScanCreate, lowerJawModel: Blob, upperJawModel: Blob) {
    const formData = new FormData();
    formData.append('data', new Blob([JSON.stringify(data)], { type: 'application/json' }));
    formData.append('lowerJawModel', lowerJawModel);
    formData.append('upperJawModel', upperJawModel);

    return Api.postFile<string>('/jaws-scans', formData); // returns scan ID
  },

  delete(id: string) {
    return Api.delete<void>(`/jaws-scans/${id}`);
  },

  update(id: string, data: JawsScanUpdate) {
    return Api.put<JawsScanSummaryResponse>(`/jaws-scans/${id}`, data);
  },
};

export default JawsScanApi;
